import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import { alterSiteDrawer } from '~/data/actions/siteActions'

export default function DestroyLandingPage({ landingPage, onFinish = () => {} }) {
    const dispatch = useDispatch()
    const [deleting, setDeleting] = useState(false)

    const onConfirm = async () => {
        setDeleting(true)
        try {
            await axios.delete('/landingpage/' + landingPage.id)
            dispatch(alterSiteDrawer(false, false, 'right', null))
            onFinish()
        } catch (err) {
            console.log(err)
        } finally {
            setDeleting(false)
        }
    }

    const onCancel = () => {
        dispatch(alterSiteDrawer(false, false, 'right', null))
    }

    return (
        <div>
            <h4 className='mar-b24'>Are you sure you want to delete the {landingPage.formName} landing page?</h4>
            <div className='mar-b24'>All linked forms and stats will also be deleted</div>
            <div className='row'>
                <div className='col-xs-6'>
                    <Button
                        text={i18n.t('yes')}
                        disabled={deleting}
                        className={'button-primary button-fullwidth'}
                        onClick={onConfirm}
                        iconLeft={<Icons icon='tick' />}
                    />
                </div>
                <div className='col-xs-6'>
                    <Button
                        className='button-fullwidth'
                        disabled={deleting}
                        text={i18n.t('no')}
                        onClick={onCancel}
                    />
                </div>
            </div>
        </div>
    )
}
